import { createContext, useContext, useState, ReactNode } from "react";

type RadarPlayerCtx = {
  currentImageIndex: number;
  setCurrentImageIndex: React.Dispatch<React.SetStateAction<number>>;
  isPlaying: boolean;
  setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>;
  playbackSpeedMs: number;
  setPlaybackSpeedMs: React.Dispatch<React.SetStateAction<number>>;
};

const RadarPlayerContext = createContext<RadarPlayerCtx | null>(null);

export function RadarPlayerProvider({ children }: { children: ReactNode }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [playbackSpeedMs, setPlaybackSpeedMs] = useState(1200);

  return (
    <RadarPlayerContext.Provider
      value={{
        currentImageIndex,
        setCurrentImageIndex,
        isPlaying,
        setIsPlaying,
        playbackSpeedMs,
        setPlaybackSpeedMs,
      }}
    >
      {children}
    </RadarPlayerContext.Provider>
  );
}

export function useRadarPlayer() {
  const ctx = useContext(RadarPlayerContext);
  if (!ctx) throw new Error("useRadarPlayer must be used within RadarPlayerProvider");
  return ctx;
}
